import {
    IAnalyticsModelResponse,
    IPropertyChild,
} from '@kcftech/prometheustypescriptapiclient';
import { MemoizedTable } from 'components/data_table/Table';
import { TableColumn } from 'components/data_table/types';

export type ParametersTableProps = Readonly<{
    analyticsModel: IAnalyticsModelResponse;
}>;

export function ParametersTable({ analyticsModel }: ParametersTableProps) {
    const columns: TableColumn<IPropertyChild>[] = [
        {
            id: 'Name',
            header: () => 'Name',
            value: ({ rowData }) => rowData.PropertyName,
            primary: true,
        },
        {
            id: 'Type',
            header: () => 'Type',
            value: ({ rowData }) => rowData.PropertyValueType,
        },
        {
            id: 'Required',
            header: () => 'Required',
            value: ({ rowData }) => (rowData.PropertyRequired ? 'Yes' : 'No'),
        },
    ];

    return (
        <div className="p-20">
            {analyticsModel.Properties.length === 0 ? (
                <span>No parameters</span>
            ) : (
                <MemoizedTable
                    lockHeaders
                    maxHeight="50rem"
                    data={analyticsModel.Properties}
                    rowKey={(property) => property.PropertyId}
                    showPageSizeDropdown={false}
                    columns={columns}
                />
            )}
        </div>
    );
}
